import React from 'react';
import {
    CircularProgress,
} from '@mui/material';

const WidgetCustomLoader = () => (
    <div style={{ padding: '24px', textAlign: 'center' }}>
        <CircularProgress />
        <br />
        <b>Cargando...</b>
    </div>
);

export default WidgetCustomLoader;
